import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import { DOODLE_COATS, DOODLE_COATS_CONFIG, GROOMING_PROFILE_KEYS } from './constants'
import useGroomingProfile from './hooks/useGroomingProfile'
import { getAllowedGroomingServicesForPet } from './helpers'

const DoodleCoatType = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading } = useGroomingProfile()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			const { coat_length, grooming_level } = DOODLE_COATS_CONFIG[type] || {
				coat_length: '',
				grooming_level: ''
			}

			newValues[GROOMING_PROFILE_KEYS.coat_type] = type
			newValues[GROOMING_PROFILE_KEYS.coat_length] = coat_length
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = grooming_level

			const allowed_grooming_services = getAllowedGroomingServicesForPet(grooming_level)
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = allowed_grooming_services

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		const o = DOODLE_COATS.map(({ label, src, type }) => {
			return {
				title: label,
				image: src,
				disabled: loading || wizard_state[attr] === type,
				selected: wizard_state[attr] === type,
				onSelected: () => handleSelection(type)
			}
		})

		return o
	}, [handleSelection, loading, wizard_state, attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default DoodleCoatType
